import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import useBrandProvider, { generateUrls } from '@hooks/useBrandProvider'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { BrandProviderModel } from '@models/types'

type BrandProviderListItemItemProps = {
  brandProvider: BrandProviderModel,
}

const BrandProviderListItem = (props: BrandProviderListItemItemProps) => {
  const { brandProvider } = props

  const {
    callbacks: {
      deleteBrandProvider: deleteFn,
    },
    brand: {
      title,
    },
  } = useBrandProvider(brandProvider)

  const { editBrandProviderUrl } = generateUrls(brandProvider)

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: { deleteString: 'remove', entityName: 'Brand Provider' },
  }

  return (
    <DashboardModuleListItem title={title}>
      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            marginRight="medium"
            // @ts-expect-error TS2345
            onClick={() => confirmDelete(confirmDeletePayload)}
            type="delete"
          />

          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            href={`${editBrandProviderUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}

export default BrandProviderListItem
